<panel width="400">
	<h1>{{ 'reason.create-new-category.headline' | translate }}</h1>
	<section>
		<custom-input [label]="'reason.create-new-category.name' | translate"
					  [placeholder]="'reason.create-new-category.name-placeholder' | translate"
					  [(value)]="reasonCategory.name"
					  [required]="true"></custom-input>
	</section>
	<section>
		<button confirm #saveButton (click)="save()">{{ 'general.save' | translate }}</button>
	</section>
	<list-view [emptyLabel]="'reason.reason-list.reason-list-empty-label'" class="scrollable">
		<header defaultSort="ascending">{{ 'general.name' | translate }}</header>
		<header></header>
		<row *listData="let category from reasonCategories" [highlighted]="selectedReasonCategory.id == category.id" (action)="selectReasonCategory(category)">
			<column>{{ category.name}}</column>
			<column align-right><icon [ngClass]="{ 'disabled': !canDelete(category) }" (click)="deleteReasonCategory(category)" type="trash-alt" /></column>
		</row>
	</list-view>
</panel>
